import React from "react"
import PropTypes from "prop-types"
import { useSiteLocation } from "../../hooks"
import { toCapitalize } from "../../utils/helpers/common"

const Copyright = routeParams => {
  const siteLocation = useSiteLocation(routeParams?.location) // boston,sydney,toronto
  const cityName = toCapitalize(siteLocation)

  return (
    <div className="copyright-container flex flex-wrap justify-between py-8">
      <div className="label flex justify-center w-full sm:w-auto">
        <div className="link">&copy; Red Soda {new Date().getFullYear()}</div>
      </div>
      <div className="policy-link flex justify-around w-full sm:w-auto pt-2 sm:pt-0">
        <div className="link sm:ml-4">
          <a
            rel="noopener noreferrer"
            target="_blank"
            href={`/RS-Privacy-Policy-Terms-of-Use-(${cityName}).pdf`}
            download
          >
            Privacy Policy
          </a>
        </div>
      </div>
    </div>
  )
}

Copyright.propTypes = {
  routeParams: PropTypes.object,
}

export default Copyright
